export const loginAction = (payload) => {
    return {
      type: "login",
      payload,
    };
};

export const questionnaireAction1 = (payload) => {
  return {
    type: "questionnaire1",
    payload,
  };
};

export const questionnaireAction2 = (payload) => {
  return {
    type: "questionnaire2",
    payload,
  };
};

export const questionnaireAction3 = (payload) => {
  return {
    type: "questionnaire3",
    payload,
  };
};


export const questionnaireAction4 = (payload) => {
  return {
    type: "questionnaire4",
    payload,
  };
};

export const questionnaireAction5 = (payload) => {
  return {
    type: "questionnaire5",
    payload,
  };
};

export const questionnaireAnswers = (payload) => {
  return {
    type: "questionnaireanswers",
    payload,
  };
};

export const questionnaireTitle = (payload) => {
  return {
    type: "questionnaireTitle",
    payload,
  };
};